<template>
  <div class="row row--15 service-wrapper">
    <div class="col-lg-4 col-md-6 col-sm-6 col-12 mt--10" v-for="(service, index) in serviceList" :key="index">
      <div :class="`service ${serviceStyle} ${checkTextAlign}`" data-aos="fade-up" data-aos-delay="70">
        <div class="image" v-if="userLogin === false">
          <img style="width: 100%" :src="service.image" alt="Service" />
        </div>
        <!-- :class="{ 'background-proscon_dark': userLogin === false, '': userLogin === true }" -->
        <div class="image" v-if="userLogin === true">
          <img style="width: 98%" :src="service.image2" alt="Service" v-if="index != 1 && index != 3 && index != 11" />
          <img style="width: 100%" :src="service.image2" alt="Service" v-if="index == 1" />
          <img style="width: 77%" :src="service.image2" alt="Service" v-if="index == 3" />
          <img style="width: 88%; padding-top: 20%" :src="service.image2" alt="Service" v-if="index == 11" />
        </div>
        <div class="content">
          <h4 class="title w-600 mt--10" style="width: 100%">
            <span v-text="service.title" />
          </h4>
          <p class="description b1 color-gray mb--0" v-text="service.description" />
        </div>
      </div>
    </div>
    <!-- <div class="text-center mt-5">
      <router-link class="btn-default btn-icon mt-5" to="#"> Read More </router-link>
    </div> -->
  </div>
</template>

<script>
import Icon from '../../icon/Icon'

export default {
  name: 'ServiceOne',
  components: { Icon },
  props: {
    serviceStyle: {
      type: String
    },
    iconSize: {
      type: String | Number,
      default: 62
    },
    textAlign: {
      type: String,
      default: 'left'
    }
  },
  data() {
    return {
      serviceImages: [
        { dark: require('@/assets/images/Newlandindpage/Mask Group 2913@2x.png'), light: require('../../../assets/images/Newlandindpage/lightmode/1.png') },
        { dark: require('@/assets/images/Newlandindpage/Mask Group 2914@2x.png'), light: require('../../../assets/images/Newlandindpage/lightmode/2.png') },
        { dark: require('@/assets/images/Newlandindpage/Mask Group 2915@2x.png'), light: require('../../../assets/images/Newlandindpage/lightmode/3.png') },
        { dark: require('@/assets/images/Newlandindpage/Mask Group 2916@2x.png'), light: require('../../../assets/images/Newlandindpage/lightmode/g1.png') },
        { dark: require('@/assets/images/Newlandindpage/Mask Group 2917@2x.png'), light: require('../../../assets/images/Newlandindpage/lightmode/555.png') },
        { dark: require('@/assets/images/Newlandindpage/Mask Group 2918@2x.png'), light: require('../../../assets/images/Newlandindpage/lightmode/666.png') },
        { dark: require('@/assets/images/Newlandindpage/Mask Group 2920@2x.png'), light: require('../../../assets/images/Newlandindpage/lightmode/7.png') },
        { dark: require('@/assets/images/Newlandindpage/Mask Group 2919@2x.png'), light: require('../../../assets/images/Newlandindpage/lightmode/8.png') },
        { dark: require('@/assets/images/Newlandindpage/Mask Group 2915@2x.png'), light: require('../../../assets/images/Newlandindpage/lightmode/3.png') },
        { dark: require('@/assets/images/Newlandindpage/Mask Group 2923@2x.png'), light: require('../../../assets/images/Newlandindpage/lightmode/10.png') },
        { dark: require('@/assets/images/Newlandindpage/Mask Group 2922@2x.png'), light: require('../../../assets/images/Newlandindpage/lightmode/11.png') },
        { dark: require('@/assets/images/Newlandindpage/Mask Group 2924@2x.png'), light: require('../../../assets/images/Newlandindpage/lightmode/12.png') },
        { dark: require('@/assets/images/Newlandindpage/Mask Group 2925@2x.png'), light: require('../../../assets/images/Newlandindpage/lightmode/13.png') }
      ]
    }
  },
  computed: {
    serviceList() {
      return this.$t('serviceimplementation.items').map((item, index) => ({
        ...item,
        image: this.serviceImages[index].dark,
        image2: this.serviceImages[index].light
      }))
    },
    checkTextAlign() {
      if (this.textAlign === 'left') return 'text-start'
      else if (this.textAlign === 'center') return 'text-center'
      else if (this.textAlign === 'end') return 'text-end'
      else return ''
    },
    userLogin() {
      return this.$store.state.userLogin
    }
  }
}
</script>

<style>
.background-proscon_dark {
  background-image: url(../../../assets/images/Newlandindpage/lightmode/bg_proscon_dark.png);
  background-size: cover;
  background-position: -0% 0%;
  /* background-repeat: no-repeat; */
  background-position: center;
  position: absolute;
  background-attachment: fixed;
  z-index: 1;
  width: 100%;
  height: auto;
}
</style>
